import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from "@angular/core";
import { EventsService } from "../../../_services/eventsServices/events.service";
import { RowEventEmit } from "../event-page-models/row-event-emit";
import { ParentEventMessageType } from "../event-page-models/parent-event-message";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { EventEditor } from "../event-page-models/event-editor";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Component({
  selector: "parent-event-page-form-users-permissions",
  templateUrl: "create-parent-event-page-form-users-permissions.component.html",
  styleUrls: [
    "./create-parent-event-page-form-users-permissions.component.scss",
  ],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          height: "200px",
          maxHeight: "4000px",
          opacity: 1,
        })
      ),
      state(
        "closed",
        style({
          height: "1px",
          opacity: 0,
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class CreateParentEventPageFormUsersPermissions {
  @ViewChild("multiselectInput") public multiselectInput: ElementRef;
  @ViewChild("componentMain") public componentMain: ElementRef;
  @Output("menu-event") public rowEvent: EventEmitter<RowEventEmit> =
    new EventEmitter<RowEventEmit>();
  public advanceSearchOpen: boolean = false;
  public readonly $permittedEventEditors: BehaviorSubject<EventEditor[]> =
    new BehaviorSubject<EventEditor[]>([]);
  public readonly $eventEditorsSearchResults: BehaviorSubject<EventEditor[]> =
    new BehaviorSubject<EventEditor[]>([]);

  constructor(private eventsService: EventsService) {
    this.getAllUserPermissions();
    this.eventsService.permittedUsersSearchResults$.subscribe((results) => {
      const allPermittedIds = this.$permittedEventEditors
        .getValue()
        .map((u) => u.id);
      this.$eventEditorsSearchResults.next(
        results.filter((u) => !allPermittedIds.includes(u.id))
      );
    });
  }

  public search() {
    this.eventsService.parentEventMessage$.next({
      text: "החיפוש לא פעיל בדמו",
      type: ParentEventMessageType.Info,
    });
  }

  submitForm() {
    return false;
  }

  navigateToCreateEvent() {}

  public changeUserStatusHandler(eventEditor: EventEditor) {
    this.eventsService.updateUserPermissions({
      ...eventEditor,
      canEditEvent: !eventEditor.canEditEvent,
    });
  }

  public basicSearch() {
    const searchInputValue = this.multiselectInput.nativeElement.value || "";
    if (!searchInputValue.trim()) {
      return;
    }
    this.eventsService
      .searchPermittedUsers({ search: searchInputValue })
      .then();
  }

  private getAllUserPermissions(): void {
    this.eventsService
      .getAllPermittedUsers()
      .subscribe((events: EventEditor[]) => {
        this.$permittedEventEditors.next(events);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-page-form-users-permissions/create-parent-event-page-form-users-permissions.component.ts